import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { AssetLocationDto, CommunitiesDto, DivisionTblDto, LandTitleDto, LgaDto, StateDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-asset-location-table',
  templateUrl: './asset-location-table.component.html',
  styleUrls: ['./asset-location-table.component.scss']
})
export class AssetLocationTableComponent implements OnChanges {

  @Input() divisions: DivisionTblDto[];
  @Input() communities: CommunitiesDto[];
  @Input() lgas: LgaDto[];
  @Input() states: StateDto[];
  @Input() assetLocations: AssetLocationDto[];
  @Output() emitEdit = new EventEmitter<AssetLocationDto[]>();

  assetLocationArrayForm: FormGroup;
  selectedIndex = null;
  filteredDelete = [];
  constructor(private fb: FormBuilder) {}

  ngOnChanges(): void {
  this.assetLocationArrayForm = this.fb.group({AssetLocations: this.fb.array([])});
  if(this.assetLocations != null && this.assetLocations.length) {
    this.setAssetLocation(this.assetLocations);

  }
  }

  get assetLocationFormArray() {
    return this.assetLocationArrayForm.get('AssetLocations') as FormArray;
  }


  setAssetLocation(assetLocations: AssetLocationDto[]) {
   assetLocations.forEach(asset => {
      this.assetLocationFormArray.push(this.fb.group({
        StateId: asset.StateId,
        LgaId: asset.LgaId,
        DivisionId: asset.DivisionId,
        CommunityId: asset.CommunityId,
        AssetLocationAddress: asset.AssetLocationAddress,
        LandTitleId: asset.LandTitleId,
        id: asset.id
      }));
    });
  }

  addAssetLocation(asset: AssetLocationDto) {
    this.assetLocationFormArray.insert(0, this.fb.group({
      StateId: asset.StateId,
        LgaId: asset.LgaId,
        DivisionId: asset.DivisionId,
        CommunityId: asset.CommunityId,
        AssetLocationAddress: asset.AssetLocationAddress,
        LandTitleId: asset.LandTitleId,
    }));

  }

   protected filterById = <T>(id: string, lookupId: string) =>
   (fieldName: T) => fieldName[lookupId] === id;

   getStateName(id: string) {
     const found  = this.states.find( this.filterById(id, 'id'));
     return found ? found.StateName : '';
   }

   getLgaName(id: string) {
     const found = this.lgas.find(this.filterById(id, 'id'));
     return found ? found.LgaName : '';
   }

   getCommunityName(id: string) {
     const found = this.communities.find(this.filterById(id, 'id'));
     return found ? found.CommunityName : '';
   }
   getDivisionName(id: string) {
     const found = this.divisions.find(this.filterById(id, 'id'));
     return found ? found.DivisionName : '';
   }

  onDelete(value, index: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        // this.dispatchDelete.emit(id);
        this.assetLocationFormArray.removeAt(index);

        if(value != null) {
          // const val = Object.assign({}, value)
          this.filteredDelete.push(value);
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onEdit(value, index) {
    this.selectedIndex = index;
    value['index'] = index;
    this.emitEdit.emit(value);
  }

}
